import React, { useEffect, useState } from "react";
import axios from "axios";
import { useSelector } from "react-redux";
const StoreModal = ({ setShow, setSelectedBranch }) => {
  const token = useSelector((state) => state.token);
  const [branches, setBranches] = useState([]);
  const [afterApi, setAfterApi] = useState(false);
  const [cancelTokenSource, setCancelTokenSource] = useState(null);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);

  //Get Branches of Vendor
  useEffect(() => {
    const delay = 0;
    const timeoutId = setTimeout(() => {
      if (cancelTokenSource) {
        cancelTokenSource.cancel("Operation canceled by the user.");
      }

      const newCancelTokenSource = axios.CancelToken.source();
      setCancelTokenSource(newCancelTokenSource);

      const params = {
        limit: 9,
        skip: (page - 1) * 9,
        page: page,
        sortBy: "createdAt:desc",
      };

      fetchAllBranches(params, newCancelTokenSource);
    }, delay);

    return () => {
      clearTimeout(timeoutId);

      if (cancelTokenSource) {
        cancelTokenSource.cancel("Operation canceled by the user.");
      }
    };
  }, [page]);

  const fetchAllBranches = (params, cancelTokenSource) => {
    axios
      .get(`${process.env.REACT_APP_BASE_URL}/v1/vendor-branch/own`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params,
        cancelToken: cancelTokenSource.token,
      })
      .then((res) => {
        setBranches(res?.data?.rows);
        setTotalPages(res?.data?.totalPages);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  return (
    <div
      className={`w-[100%] h-[100%] fixed top-0 left-0 bg-slate-500/50 flex justify-center items-center `}
    >
      <div className="relative p-4 w-full max-w-md max-h-full z-50">
        <div className="relative bg-white rounded-lg shadow ">
          <div className="flex items-center justify-between p-4 md:p-5 border-b rounded-t ">
            <h3 className="text-lg font-semibold text-gray-900 ">Branches</h3>
            <button
              onClick={() => {
                setShow(false);
              }}
              type="button"
              className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm h-8 w-8 ms-auto inline-flex justify-center items-center  "
              data-modal-toggle="select-modal"
            >
              <svg
                className="w-3 h-3"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 14 14"
              >
                <path
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
                />
              </svg>
              <span className="sr-only">Close modal</span>
            </button>
          </div>
          {branches?.length === 0 && afterApi ? (
            <h1 className="text-center p-6 text-md">No Branch Available</h1>
          ) : (
            <div className="p-4 md:p-5">
              <ul className="space-y-4 max-h-96 overflow-y-scroll custom-scrollbar p-4">
                {branches?.map((voc, index) => (
                  <li key={index}>
                    <div
                      className="w-full p-3 
                     text-gray-900 bg-white
                    
                      border border-gray-300 rounded-lg cursor-pointer shadow-sm"
                      onClick={() => {
                        setSelectedBranch(voc);
                        setShow(false);
                      }}
                    >
                      <div className="flex gap-2 items-center justify-center">
                        <img
                          src={voc?.logo}
                          alt="store"
                          className="w-8 h-8 rounded-full"
                        />
                        <div className="w-full text-md font-semibold text-[0.95rem]">
                          {voc?.name}
                        </div>
                      </div>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default StoreModal;
